/** 提取用于签名的 API 路径（不含 query） */
export const getApiSignPath = (endpoint: string): string => {
  if (!endpoint) return ''
  if (endpoint.startsWith('http')) {
    try {
      return new URL(endpoint).pathname
    } catch {
      return endpoint.split('?')[0]
    }
  }
  return endpoint.split('?')[0]
}

/** 仅对自家 /api/* 接口签名 */
export const shouldSignApiRequest = (path: string): boolean => {
  return path.startsWith('/api/')
}

const generateNonce = (): string => Math.random().toString(36).substring(2)

const hmacSha256Base64 = async (message: string, secret: string): Promise<string> => {
  const enc = new TextEncoder()
  const key = await crypto.subtle.importKey(
    'raw',
    enc.encode(secret),
    { name: 'HMAC', hash: 'SHA-256' },
    false,
    ['sign'],
  )
  const sig = await crypto.subtle.sign('HMAC', key, enc.encode(message))
  const bytes = new Uint8Array(sig)
  let binary = ''
  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i])
  }
  return btoa(binary)
}

export type ApiSignHeaders = {
  'X-Timestamp': string
  'X-Nonce': string
  'X-Signature': string
}

/** 生成 API 防护签名头：METHOD:path:timestamp:nonce */
export const createApiSignHeaders = async (
  method: string,
  endpoint: string,
  secret: string,
): Promise<Partial<ApiSignHeaders>> => {
  if (!secret) return {}

  const path = getApiSignPath(endpoint)
  if (!shouldSignApiRequest(path)) return {}

  const timestamp = Date.now()
  const nonce = generateNonce()
  const message = `${method.toUpperCase()}:${path}:${timestamp}:${nonce}`
  const signature = await hmacSha256Base64(message, secret)

  return {
    'X-Timestamp': String(timestamp),
    'X-Nonce': nonce,
    'X-Signature': signature,
  }
}
